import { useState, useEffect } from 'react';
import axios from 'axios';

const useAccount = () => {
  const [account, setAccount] = useState({
    displayName: '',
    email: '',
    photoURL: '/assets/images/avatars/avatar_default.jpg',
  });

  useEffect(() => {
    const fetchUserData = async () => {
      const token = localStorage.getItem('token');
      const userId = localStorage.getItem('userId');

      if (token && userId) {
        try {
          const config = {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          };

          const response = await axios.get(`${process.env.REACT_APP_API_URL}/getUserById?userId=${userId}`, config);

          if (response.status === 200) {
            const userData = response.data.data;

            // Check if an avatar number is already saved, if not, generate a new one
            let avatarNumber = localStorage.getItem('avatarNumber');
            if (!avatarNumber) {
              avatarNumber = Math.floor(Math.random() * 9) + 1;
              localStorage.setItem('avatarNumber', avatarNumber);
            }

            setAccount({
              displayName: userData.fullName,
              email: userData.email,
              photoURL: `/assets/images/avatars/male/avatar_${avatarNumber}.jpg`,
            });
          } else {
            console.error('Request failed with status:', response.status);
          }
        } catch (error) {
          console.error('Error fetching user data:', error);
        }
      }
    };

    fetchUserData();
  }, []);

  return account;
};

export default useAccount;
